<script lang="ts" setup>
import type { Props } from './types'

defineProps<Props>()

</script>

<script lang="ts">
export default {
  name: 'PdMultimediaContentCard'
}
</script>

<template>
  <button
    class="pd-multimedia-content__card"
    :data-lh-id="dataLhId">
    <div class="relative pointer-events-none">
      <img
        :alt="alt"
        class="w-72 h-72 rounded-[4px] lg:w-100 lg:h-100"
        :src="imgSrc">

      <div class="pd-multimedia-content__card-icon-holder w-40 h-40 items-center justify-center bg-white rounded-full flex absolute top-1/2 left-1/2 z-10 -translate-x-1/2 -translate-y-1/2 pointer-events-none">
        <component
          :is="icon"
          :class="iconClass" />
      </div>
    </div>

    <div class="ml-12 pointer-events-none flex flex-col items-start">
      <p
        v-if="title"
        class="text-16 font-medium lg:text-20">
        {{ title }}
      </p>

      <span class="text-primary-600 font-medium underline mt-4">
        {{ ctaText }}
      </span>
    </div>
  </button>
</template>

<style lang="scss">
.pd-multimedia-content__card {
  @apply flex flex-row items-center p-8 w-full;

  border-radius: 5px;
  box-shadow: 0 2px 4px 0 rgba(72 91 87 / 20%);
}
</style>
